import React from "react";
import { Box } from "@UI/Components/Box/Box";
import { useRecommendedServiceProviders } from "../hooks/useRecommendedServiceProviders";
import { SPRecommendationCard } from "./RecommendationCard/SPRecommendationCard";
import { RecommendationCardSkeleton } from "./RecommendationCard/RecommendationCardSkeleton";
import { RecommendationCarousel } from "./RecommendationCarousel/RecommendationCarousel";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import SwiperClass from "swiper";

const SKELETON_COUNT = 3;

export const SPRecommendationCarousel = () => {
  const { serviceProviders, isLoading, isError } =
    useRecommendedServiceProviders();
  if (
    isError ||
    (!isLoading && (!serviceProviders || serviceProviders.length === 0))
  ) {
    return null;
  }

  const handleSlideChange = (swiper: SwiperClass) => {
    if (typeof window !== "undefined" && (window as unknown as { dataLayer?: object[] }).dataLayer) {
      (window as unknown as { dataLayer: object[] }).dataLayer.push({
        event: "carousel_scroll",
        carousel_name: "home_listposter_sp_recommendation",
        slide_index: swiper.activeIndex,
      });
    }
  };

  return (
    <RecommendationCarousel
      onSlideChange={handleSlideChange}
      title={
        <>
          <FormattedMessage
            id="recommendations.service_providers.titlePrefix"
            defaultMessage="Meet our top"
          />{" "}
          <Box as="span" textStyle="gradient-rt">
            <FormattedMessage
              id="recommendations.service_providers.titleHighlight"
              defaultMessage="SuperTalents"
            />
          </Box>
        </>
      }
      subtitle={
        <FormattedMessage
          id="recommendations.service_providers.subtitle"
          defaultMessage="Service providers known for quality and reliability, notified in priority when you create a request."
        />
      }
      slideWidth="275px"
      spaceBetween={12}
    >
      {isLoading
        ? Array.from({ length: SKELETON_COUNT }, (_, i) => (
            <RecommendationCardSkeleton key={i} coverHeight="150px" />
          ))
        : serviceProviders?.map((sp, i) => (
            <SPRecommendationCard key={i} {...sp} coverHeight="175px" />
          ))}
    </RecommendationCarousel>
  );
};
